module.exports = __webpack_public_path__ + "img/Tempitem.47536c14.svg";